import { fieldFallbackLabel } from "@smart/bridge-intake-components-dom";
import { Badge } from "@smart/itops-sb-design-system-dom";

import { EditableText } from "../editor";
import { GqlGroupValues } from "../types";

type RemovedGroupCardProps = {
  group: GqlGroupValues;
};

export const RemovedGroupCard = ({ group }: RemovedGroupCardProps) => (
  <div className="border-2 border-dashed border-blue-360 rounded w-full max-w-[92.6rem] mx-auto bg-blue-60 p-[0.4rem] mb-[0.8rem]">
    <div className="flex flex-col gap-small p-[1rem] pl-[3.6rem] pb-[1.5rem]">
      <div className="relative flex items-start gap-small">
        <span className="absolute -left-[1rem] top-[1.1rem] w-3 h-3 rounded-full bg-blue-460 flex-0" />
        <EditableText
          text={group.label || fieldFallbackLabel.group}
          fontWeight="semibold"
          isEditor
          disabled
          onChange={() => {}}
          onComplete={async () => {}}
        />
        <Badge label="Removed" theme="information" className="mt-[0.4rem]" />
      </div>
      <p className="text-neutral-500 text-caption ml-[0.8rem]">
        This group was removed in this version. It won&apos;t appear once you
        publish.
      </p>
    </div>
  </div>
);
